import React from 'react';

import { iaRa } from 'lib/helpers/utility';

import { getProcedureName } from 'components/practice/charts/ClinicalNote/shared/CPTCodes/lib/helpers';

import OverflowChipList from './OverflowChipList/OverflowChipList';

const ProceduresCell = ({ data, node, procedureCodes }) => {
  const procedures = iaRa(data?.procedures);
  const finalProcedures =
    procedureCodes || procedures.map((procedure) => getProcedureName(procedure)).filter(Boolean);

  if (node?.group) return null;

  return (
    <div className="flex h-full items-center justify-center">
      <OverflowChipList items={finalProcedures} />
    </div>
  );
};

export default ProceduresCell;
